import NestedForm from "@stimulus-components/rails-nested-form/dist/stimulus-rails-nested-form.umd.js"

export default class extends NestedForm {
  add (event) {
    super.add(event)

    const allTrainingSessionDays = this.element.querySelectorAll(".nested-form-wrapper")
    const currentTrainingSessionDayElement = allTrainingSessionDays[allTrainingSessionDays.length - 1]

    if (allTrainingSessionDays !== undefined) { // handle first insert case
      const positionInput = currentTrainingSessionDayElement.querySelector("input[name*='position']")
      positionInput.value = allTrainingSessionDays.length
    }
  }
}
